import {useEffect, useRef, useState} from 'react'
import { motion } from "framer-motion";


import '../assets/css/pastorais.css'
import LateralMenu from './LateralMenu';
import BoxComp from './BoxComp.jsx';
import GlobalVars from './subComponents/GlobalVars.jsx';


// var width_ = window.innerWidth;
// var height_ = window.innerHeight;

export const Pastorais = ({ativaResp}) => {

    const lateralMenu = useRef()
    const [pastoralSelect, setPastoralSelect] = useState("PASCOM - Pastoral da Comunicação")
    const pastoraisList = GlobalVars.Pastorais

    return <>
        <LateralMenu ativaResp={ativaResp} ref={lateralMenu}/>
        <div className="containerPrincipal pastorais" style={{maxHeight: "100vh"}}>
        <BoxComp lateralMenu={lateralMenu}/>
        <div className="containerPastorais">
        
            
            <div className="topButtons">

                <div className="titlePage">Pastorais & Movimentos</div>
                <select className="selectPastorais"
                    defaultValue="PASCOM - Pastoral da Comunicação"
                    onChange={e => setPastoralSelect(e.target.value)}>

                <option value="PASCOM - Pastoral da Comunicação">PASCOM - Pastoral da Comunicação</option>
                {Object.keys(pastoraisList).map((item, index)=>{
                    return <option value={item} key={"past"+index} >{pastoraisList[item].title}</option>
                })}
                </select>

            </div>

            <div className="divider"></div>

            <div className="conteudoPastorais scrollbar">
                {pastoralSelect ? pastoraisList[pastoralSelect].text
                    : <></>}

            </div>

        </div>

        </div>
    </>
}

export default Pastorais;